// extracted by mini-css-extract-plugin
export default {"discountBarWrapper":"discount-bar_discountBarWrapper__110Ft","selectWrapper":"discount-bar_selectWrapper__G4js9","select":"discount-bar_select__8wajy"};